
import React, { useState } from 'react';
import home from '../src/icon/Home.png'
import profile from '../src/icon/profile.png'
import cal from '../src/icon/cal.png'
import ad from '../src/icon/admin.png'
import cash from '../src/icon/cash.png'
import { useLocation, useNavigate } from 'react-router-dom';
import { getAccount } from './supabase';
const NavBar = () => {
    const location = useLocation()
    const navigation = useNavigate()
    const [admin, setAdmin] = useState(false)

    const checkIFAdmin = async () => {
        const mail = localStorage.getItem('mail')

        const account = await getAccount(mail)
        
        if (account[0].admin) { 
           setAdmin(true)
           localStorage.setItem('admin', true)
        }
        else {
            setAdmin(false) 
            localStorage.setItem('admin', false)
        }


    }

    React.useEffect(() => {
        checkIFAdmin()
    }
    ,[])

     return (
        <div className="bg-[#1E2021] w-full h-fit flex flex-row border-t border-[#2A2A2A] justify-between p-2 fixed bottom-0">
            {location.pathname === "/home" ? <button onClick={() =>   navigation('/home')} className='bg-[#156C1E15] p-4 flex flex-row rounded-xl'>
                <img src={home} />
                <p className='font-bold ml-2 text-[#839262]'>Home</p>
            </button> : <button onClick={() =>   navigation('/home')} className='p-4 flex flex-row rounded-xl'>
                <img src={home} />
            </button>}

            {location.pathname === "/partite" ?  <button onClick={() =>   navigation('/partite')} className='bg-[#156C1E15] p-4 flex flex-row rounded-xl'>
                <img src={cal} />
                <p className='font-bold ml-2 text-[#839262]'>Partite</p>
            </button> : <button onClick={() =>   navigation('/partite')} className='p-4 flex flex-row rounded-xl'>
                <img src={cal} />
            </button>}

            {location.pathname === "/profilo" ?  <button onClick={() =>   navigation('/profilo')} className='bg-[#156C1E15] p-4 flex flex-row rounded-xl'>
                <img src={profile} />
                <p className='font-bold ml-2 text-[#839262]'>Profilo</p>
            </button>:  <button onClick={() =>   navigation('/profilo')} className='p-4 flex flex-row rounded-xl'>
                <img src={profile} />
            </button>}

{admin ? location.pathname === "/admin" ?  <button onClick={() =>   navigation('/admin')} className='bg-[#156C1E15] p-4 flex flex-row rounded-xl'>
                <img src={ad} />
                <p className='font-bold ml-2 text-[#839262]'>Admin</p>
            </button>:  <button onClick={() =>   navigation('/admin')} className='p-4 flex flex-row rounded-xl'>
                <img src={ad} />
            </button> : null}

            {admin ? location.pathname === "/soldi" ?  <button onClick={() =>   navigation('/soldi')} className='bg-[#156C1E15] p-4 flex flex-row rounded-xl'>
                <img src={cash} />
                <p className='font-bold ml-2 text-[#839262]'>Soldi</p>
            </button>:  <button onClick={() =>   navigation('/soldi')} className='p-4 flex flex-row rounded-xl'>
                <img src={cash} />
            </button> : null}
            

           
           
            
        </div>

    );
};

export default NavBar;
